module.exports = __webpack_public_path__ + "fonts/NotoSans-ExtraBold.d047644.ttf";